import { LeadsPlan } from "@/models/LeadsState";
import { leadsConstants } from '@puls/puls-common-constants';

export default { 
	getServicesForPayment: (selectedPlan: LeadsPlan) => {
		if (!selectedPlan) return;
		const { title, service_id, price, id } = selectedPlan;
		const planObj: { title: string, id: number, payment?: number } = {
			title,
			id: service_id
		}

		if (id === leadsConstants.CUSTOM_PACK_PLAN_ID) { 
			planObj.payment = price;
		}

		return [planObj];
	},
	generatePlanItem: ({ id, service_id, title, price, price_per_lead, leads, label }: 
		{id: number, service_id: number, title: string, price: number, price_per_lead: number, leads: number, label?: string}) => {
		const plan: LeadsPlan = { 
			id,
			service_id,
			title,
			price,
			price_per_lead,
			leads_amount: leads
		}

		if (label) { 
			plan.label = label;
		}

		return plan;
	}
}
